const searchLink = {
  name: 'search',
  label: 'Search',
  sideLabel: 'Find a Bank',
  path: '/search',
  useAnchor: true,
  isActive: true,
  target: null,
}

const blogLink = {
  name: 'blog',
  label: 'Blog',
  sideLabel: 'Our Blog',
  path: 'https://www.betterbankingoptions.com/',
  useAnchor: true,
  isActive: false,
  target: '_blank',
}

/*
const methodologyLink = {
  name: 'methodology',
  label: 'Metrics',
  sideLabel: 'Our Metrics',
  path: '/methodology/quality-lending',
  useAnchor: false
}
*/

const methodologyLink = {
  name: 'methodology',
  label: 'Metrics',
  sideLabel: 'Our Metrics',
  path: 'https://www.betterbankingoptions.com/metrics',
  useAnchor: true,
  isActive: false,
  target: '_blank',
}

const aboutLink = {
  name: 'aboutUs',
  label: 'About',
  sideLabel: 'About Us',
  path: 'https://www.betterbankingoptions.com/our-mission',
  useAnchor: true,
  isActive: false,
  target: '_blank',
}

export const links = [searchLink, methodologyLink, blogLink, aboutLink]
